// LF360-1818: the backend blocks deleting/deactivating an object that is still
// referenced by a scenario, onboarding survey or task graph. Single delete /
// toggle return 400 { error: { code: 'ENTITY_REFERENCED', message, references } };
// bulk returns 200 { failed: [{ id, code: 'ENTITY_REFERENCED', references }] }.

export const REFERENCED_ERROR_CODE = "ENTITY_REFERENCED";

// True when a caught request error is a blocked-because-referenced response.
export const isReferencedError = (err) =>
  err?.response?.data?.error?.code === REFERENCED_ERROR_CODE;

// True when a bulk response's `failed` list contains a referenced failure.
export const hasReferencedFailure = (failed = []) =>
  Array.isArray(failed) && failed.some((f) => f?.code === REFERENCED_ERROR_CODE);

// Activation blocked because the published flow references a missing object.
export const BROKEN_REFERENCES_ERROR_CODE = "BROKEN_REFERENCES";

export const isBrokenReferencesError = (err) =>
  err?.response?.data?.error?.code === BROKEN_REFERENCES_ERROR_CODE;

// The server-provided message for an error response, if any.
export const errorMessageOf = (err) => err?.response?.data?.error?.message || null;
